import { Action, ActionReducer, createFeature } from '@ngrx/store';
import {
    AuctionsLoadedAction,
    AuctionsPageServiceActions,
    AuctionsPageUIActions,
    UpdateAuctionStatusAction,
} from './auctions-page.actions';
import { GetFeaturedAuctions200ResponseAllOfDataInner } from '@viewbid/ts-angular-client';

export const auctionsPageFeatureKey: string = 'auctions';

export interface AuctionsPageState {
    result: GetFeaturedAuctions200ResponseAllOfDataInner[];
    isLoading: boolean;
    hasError: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    buyerPremium: number;
}

export const initialState: AuctionsPageState = {
    result: [],
    isLoading: false,
    hasError: false,
    page: 0,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
    buyerPremium: 0,
};

export const auctionsPageReducer: ActionReducer<AuctionsPageState, Action> = (
    state: AuctionsPageState = initialState,
    action: Action,
): AuctionsPageState => {
    switch (action.type) {
        case AuctionsPageUIActions.LoadAuctionsAction: {
            const newState: AuctionsPageState = { ...state };
            newState.isLoading = true;
            newState.hasError = false;
            newState.result = [];
            newState.page = 0;
            newState.pageSize = 0;
            newState.totalCount = 0;
            newState.totalPages = 0;
            return newState;
        }
        case AuctionsPageServiceActions.AuctionsLoadedAction: {
            const auctionsLoadedAction: AuctionsLoadedAction =
                action as AuctionsLoadedAction;
            const newState: AuctionsPageState = { ...state };
            newState.isLoading = false;
            newState.hasError = false;

            newState.result = auctionsLoadedAction.props.result
                .data as GetFeaturedAuctions200ResponseAllOfDataInner[];
            // newState.count = auctionsLoadedAction.props.result.count ?? 0;
            newState.page = auctionsLoadedAction.props.result.page ?? 0;
            newState.pageSize = auctionsLoadedAction.props.result.pageSize ?? 0;
            newState.totalCount =
                auctionsLoadedAction.props.result.totalCount ?? 0;
            newState.totalPages =
                auctionsLoadedAction.props.result.totalPages ?? 0;
            return newState;
        }
        case AuctionsPageServiceActions.LoadAuctionsFailedAction: {
            const newState: AuctionsPageState = { ...state };
            newState.isLoading = false;
            newState.hasError = true;
            newState.result = [];
            newState.page = 0;
            newState.pageSize = 0;
            newState.totalCount = 0;
            newState.totalPages = 0;
            return newState;
        }
        case AuctionsPageServiceActions.UpdateAuctionStatusAction: {
            const updateAuctionStatusAction: UpdateAuctionStatusAction =
                action as UpdateAuctionStatusAction;
            const newState: AuctionsPageState = {
                ...state,
                result: state.result.map(
                    (auction: GetFeaturedAuctions200ResponseAllOfDataInner) =>
                        auction.id === updateAuctionStatusAction.props.auctionId
                            ? {
                                  ...auction,
                                  status: updateAuctionStatusAction.props
                                      .status,
                              }
                            : auction,
                ),
            };
            return newState;
        }
        default:
            return state;
    }
};

// eslint-disable-next-line
export const auctionsPageFeature = createFeature({
    name: auctionsPageFeatureKey,
    reducer: auctionsPageReducer,
});
